import { titleCase } from './SqliteHelp.js'
export function makeStoreCode(dbName, tableNames, tableDatas) {
    tableNames = JSON.parse(JSON.stringify(tableNames));
    tableDatas = JSON.parse(JSON.stringify(tableDatas));
    let storeCode = ""
    tableNames.forEach((tableName) => {
        storeCode = storeCode + `
  /// ${titleCase(tableName)} 页面查询参数管理
  set${titleCase(tableName)}ParamsForm(Map paramsForm) async {
    final prefs = await SharedPreferences.getInstance();
    await prefs.setString('${tableName}_params', json.encode(paramsForm));
  }
  get${titleCase(tableName)}ParamsForm() async {
    final prefs = await SharedPreferences.getInstance();
    final paramsForm = json.decode(prefs.getString('${tableName}_params') ?? '{}');
    return paramsForm;
  }
  /// ${titleCase(tableName)} 页面表单数据管理
  set${titleCase(tableName)}DataForm(Map dataForm) async {
    final prefs = await SharedPreferences.getInstance();
    await prefs.setString('${tableName}_form', json.encode(dataForm));
  }
  get${titleCase(tableName)}DataForm() async {
    final prefs = await SharedPreferences.getInstance();
    final dataForm = json.decode(prefs.getString('${tableName}_form') ?? '{}');
    return dataForm;
  } 

`
    });

    return `/// Author: Samle
import 'dart:convert';
import 'package:shared_preferences/shared_preferences.dart';

/// 页面参数使用状态管理进行缓存
class PageStore {
  ${storeCode}}
`
}